export default __webpack_public_path__ + "static/media/Logo.d23b84e0.svg";